export default __webpack_public_path__ + "static/psklogo-fca70d5ebe71703033aeea3c95276b8f.png";